import './index.scss';
import './colours.scss';

import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import App from './parts/system/pages/App';
import {store} from "./services/store/store"
import {Provider} from "react-redux";
import {createRoot} from "react-dom/client";

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<React.StrictMode>
    <BrowserRouter>
        <Provider store={store}>
            <App />
        </Provider>
    </BrowserRouter>
</React.StrictMode>);
